import cx from 'classnames';
import { PropsWithChildren, ReactNode } from 'react';
import Box, { BoxStyleProps } from '../Box';

import styles from './EmojiFeedback.module.css';

export interface EmojiFeedbackProps extends BoxStyleProps {
  className?: string;
  title?: string;
  selectedValue?: string;
  options: ReactNode;
  onSelect?: (value: string) => void;
}

function EmojiFeedback({
  className,
  title,
  children,
  selectedValue,
  options,
  onSelect,
  ...otherProps
}: PropsWithChildren<EmojiFeedbackProps>): JSX.Element {
  return (
    <Box className={cx(styles['base'], className)} {...otherProps}>
      {title && (
        <div className={styles['title']} id="feedback-title">
          {title}
        </div>
      )}
      <div
        className={styles['options']}
        role="listbox"
        aria-labelledby="feedback-title"
      >
        {options}
      </div>
      {children}
    </Box>
  );
}

export default EmojiFeedback;
